//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {queryuserbalance} from '../../api/pay'
import {logout} from '../../api/login'
import { isServicePlanAllowed } from '@/api/servicePlan'

export default {
  name: 'More',
  data () {
    return {
      show: false,
      showOut: false,
      iswx: '',
      userbalance: {
        balance_sms: 0,
        balance_voice: 0
      }
    }
  },
  computed: {
    isServicePlanAllowed () {
      return isServicePlanAllowed()
    }
  },
  methods: {
    getSumData () {
      let data = {
        phone: this.$store.getters.get_user
      }
      queryuserbalance(data).then(res => {
        this.userbalance = res.data.userbalance
      }).catch(() => {})
    },
    showUser () {
      this.show = {display: 'block'}
    },
    logout () {
      let url = ''
      let host = window.location.host
      if (host === 'aimtycloud.anfangwx.aimtyiot.cn') { // 艾米安防云
        url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx78dc92678be7c2e6&redirect_uri=http%3A%2F%2Faimtycloud.anfangwx.aimtyiot.cn&response_type=code&scope=snsapi_base&#wechat_redirect'
      } else if (host === 'anfangwxtest.aimtyiot.cn') { // 测试
        url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd4c4de465ee2a3df&redirect_uri=http%3A%2F%2Fanfangwxtest.aimtyiot.cn&response_type=code&scope=snsapi_base&#wechat_redirect'
      } else {
        url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd4c4de465ee2a3df&redirect_uri=http%3A%2F%2Fanfangwx.aimtyiot.cn&response_type=code&scope=snsapi_base&#wechat_redirect'
      }
      let vm = this
      logout().then(res => {
        console.log(res)
        this.$store.commit('set_token', '')
        this.$store.commit('set_openid', '')
        if (res.code === 200) {
          this.closeSub()
          if (vm.isWx()) {
            location.assign(url)
            this.showOut = false
          } else {
            this.$router.push('/')
            this.showOut = false
          }
        } else {
          if (vm.isWx()) {
            location.assign(url)
            this.showOut = false
          } else {
            this.$router.push('/')
            this.showOut = false
          }
        }
      }).catch(err => {
        this.$store.commit('set_token', '')
        this.$store.commit('set_openid', '')
        console.log(err)
        if (vm.isWx()) {
          location.assign(url)
          this.showOut = false
        } else {
          this.$router.push('/')
          this.showOut = false
        }
      })
    },
    openFamily () {
      // this.$router.push('/SetFamily')
      this.$router.push('/familyManagement')
    },
    openPay () {
      this.$router.push('/payDetails')
    },
    openServicePlanList () {
      this.$router.push('/deviceServiceList')
    }
  },
  created () {
    this.iswx = this.$store.getters.get_iswx
    this.getSumData()
  }
}



// WEBPACK FOOTER //
// ./src/components/more/More.vue